import type { QuestionWithSlide } from '@mentimeter/presentation-schema/api-types-overrides';
import type { Question } from '@mentimeter/legacy-series-types/question';
import type { Slide as InternalSlide } from '../../../compatibility-overrides/presentation-types';
import { isProxyInstance } from '../../../utils/is-proxy-instance';
import { getCommonSlideCompatibilityHandler } from '../../common/get-common-slide-compatibility-handler';
import { presentationSlidePropertyKeys } from './constants';

export function createPresentationSlideCompatibilityLayer(
  _target: unknown,
): QuestionWithSlide {
  const target = _target as Question | InternalSlide;

  if (isProxyInstance(target)) {
    return target as QuestionWithSlide;
  }

  const handler = getCommonSlideCompatibilityHandler(
    presentationSlidePropertyKeys,
  );

  return new Proxy(target, handler) as QuestionWithSlide;
}
